module.exports = __webpack_public_path__ + "img/stavebnidenik.064ba9c7.svg";